module.exports = __webpack_public_path__ + "img/w4g_icon.b5f6150e.svg";